import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';

import { UserMyRadiant as User, EmployeeAttendanceProvider } from '../../../providers';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { HelperMyRadiant} from '../../../providers';

import * as mapboxgl from 'mapbox-gl';
import { AppAttendance } from '../attendanceApp/attendance';

@Component({
  selector: 'attedance-detail',
  templateUrl: 'page.html'
})
export class DetailAttendance {
  loading : any;  
  parameter = {
    jarak: '0',
    time: new Date().getHours() + ":" + new Date().getMinutes(),
    date_attendance : '',    
    date_text:'',
    full_date:'',
    coordinate: '',
    type : '',
    clock_type:'Clock In',
    location:null,    
    notes:'',
    id:this.userApi.data.Employee_ID,
    code:this.userApi.data.NIK,
    name:this.userApi.data.Nama_Karyawan,
  };    
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,    
    public attendanceProvider : EmployeeAttendanceProvider,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config    
    ) {
    this.config.set('backButtonText','Detail Attendance');
    this.parameter = this.navParams.get('parameter');
  }

  
  ionViewWillEnter(){
    
  }
  ionViewDidEnter(){
    let me = this;        
  }  


}



// WEBPACK FOOTER //
// ./src/pages/attendance/detail_attendance/page.ts